import React from 'react';
import {TestimonialsCarousel} from "@gik/ui";
import {testimonials} from "@gik/marketing/testimonials";

export default function HomepageTestimonialsContainer({ className }: { className?: string }): JSX.Element {
  return (
    <div className={`homepage-testimonials-container ${className}`}>
      <div className="homepage-testimonials-content">
        <TestimonialsCarousel items={testimonials} variant="primary" />
      </div>
    </div>
  );
}
